import React from 'react'

import { ReactComponent as Icon } from './assets/InactiveButton.svg'
import widgetStyles from './assets/widget.module.scss'

const DisabledButton = props => (

  <Icon
    className={widgetStyles['support-icon']}
    onClick={props.onClick}
    data-bdd="support-unavailable-button"
  />

)

export default DisabledButton
